var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"loader"},[_c('svg',{attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{attrs:{"r":"15","cy":"50","cx":"50"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }